import React, { Component } from "react";
import { connect } from "react-redux";
import LoginView from "./LoginView";
import {
  setTokenAction,
  setTranslationsAction,
} from "../../store/Layout/actions";
import { setCurrentTabAction } from "../../store/Login/actions";

class LoginController extends Component {
  render() {
    return (
      <LoginView
        trans={this.props.trans}
        csrf_token={this.props.csrf_token}
        config={this.props.config}
        setTranslationsAction={this.props.setTranslationsAction}
        loginEmail={this.props.login}
        setTokenAction={this.props.setTokenAction}
        setCurrentTabAction={this.props.setCurrentTabAction}
        selectedTypeIndex={this.props.selectedTypeIndex}
        tabIndex={this.props.tabIndex}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    csrf_token: state.layout.csrf_token,
    trans: state.layout.trans,
    login: state.login.email,
    tabIndex: state.login.tabIndex,
    selectedTypeIndex: state.login.selectedTypeIndex,
  };
};

const mapDispatchToProps = {
  setTokenAction,
  setTranslationsAction,
  setCurrentTabAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginController);
